// ** React Imports
import * as React from 'react'
import { InputAdornment, styled, TextField, Typography } from '@mui/material'
import TextFieldError from './TextFieldError'
import TextInputLimitCounter from './TextInputLimitCounter'
import PhoneInput from 'react-phone-input-2'
interface PhoneInputFieldProps {
  isRequired?: boolean
  errorStatus?: boolean
  errorMessage?: string
  label?: string
  isFullWidth?: boolean
  inputValue?: any
  handleChange?: (value: any) => void
  isDisabled?: boolean
  customClass?: string
  countryCode?: string
  handleFocus?: (value: any) => void
  handleBlur?: (value: any) => void
  onlyCountries?: string[]
  id?: string
}

const PhoneNumberInputField: React.FC<PhoneInputFieldProps> = ({
  handleFocus,
  handleBlur,
  isRequired = false,
  errorStatus = false,
  errorMessage = '',
  label = '',
  isFullWidth = true,
  inputValue,
  countryCode = 'in',
  handleChange,
  isDisabled = false,
  customClass = '',
  onlyCountries,
  id
}) => {
  const [isFocused, setIsFocused] = React.useState(false)

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', width: isFullWidth ? '100%' : '', position: 'relative' }}
      className={customClass}
    >
      <Typography
        variant='body2'
        sx={{
          fontWeight: 500,
          fontSize: 12,
          whiteSpace: 'nowrap'
        }}
      >
        {label}
        {isRequired && <span className='text-[#CB2711]'>*</span>}
      </Typography>
      <div
        className={`!rounded-lg !shadow-sm !border-2 !h-[40px] border-solid border-yay-light
        ${isFocused && !errorStatus ? '!border-[#01cca7]' : ''}
        ${errorStatus ? '!border-red-dark' : ''}
        ${isDisabled ? 'bg-gray-lighter !border-[#D9D9D9] text-gray-dark' : ''}`}
      >
        <PhoneInput
          buttonClass={`${
            isDisabled ? '!bg-[#F5F5F5]' : '!bg-[#fff]'
          } !border-0 !rounded-lg hover: !rounded-lg !pt-[3px]`}
          inputClass={` !w-[100%] !border-0 !rounded-lg hover: !rounded-lg !pt-[3px] ${
            isDisabled ? '!bg-[#F5F5F5] border-[#F0F0F0]' : ''
          }`}
          onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
            if (typeof handleFocus === 'function') {
              handleFocus(e)
            }
            setIsFocused(true)
          }}
          onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
            setIsFocused(false)
            if (typeof handleBlur === 'function') {
              handleBlur(e)
            }
          }}
          country={'in'}
          value={inputValue}
          onChange={handleChange}
          countryCodeEditable={false}
          onlyCountries={onlyCountries}
          disabled={isDisabled}
          inputProps={{ id }}
        />
      </div>
      {errorStatus && <TextFieldError message={errorMessage} />}
    </div>
  )
}

export default PhoneNumberInputField
